export default __webpack_public_path__ + "static/media/reaction-01.93f299ce.svg";